import React from 'react';
import PropTypes from 'prop-types';
import MicrophoneIcon from './icons/MicrophoneIcon';
import SendIcon from './icons/SendIcon';

const MAX_MESSAGE_LENGTH = 5000;

const ChatInputArea = ({
  value,
  onChange,
  onSend,
  isDisabled,
  isRecording,
  isVoiceSupported,
  onMicPress
}) => {
  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      onSend();
    }
  };

  return (
    <div className="chatbot-input-area">
      <textarea
        aria-label="Type your message"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="Type a message..."
        disabled={isDisabled}
        rows={1}
        maxLength={MAX_MESSAGE_LENGTH}
      />
      <div className="chatbot-input-actions">
        {isVoiceSupported && (
          <button
            type="button"
            className={`chatbot-mic-button ${isRecording ? 'is-recording' : ''}`}
            onClick={onMicPress}
            disabled={isDisabled}
            aria-label={isRecording ? 'Stop recording' : 'Start recording'}
          >
            <MicrophoneIcon />
          </button>
        )}
        <button
          type="button"
          className="chatbot-send-button"
          onClick={onSend}
          disabled={isDisabled || !value.trim()}
          aria-label="Send message"
        >
          <SendIcon />
        </button>
      </div>
    </div>
  );
};

ChatInputArea.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onSend: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  isRecording: PropTypes.bool,
  isVoiceSupported: PropTypes.bool,
  onMicPress: PropTypes.func.isRequired
};

ChatInputArea.defaultProps = {
  isDisabled: false,
  isRecording: false,
  isVoiceSupported: false
};

export default ChatInputArea;
